import React, { useState, useEffect } from 'react';
import '../styles/AdminProductManager.css';
import AdminSidebar from "./AdminSidebar";

const AdminProductManager = () => {
    // zustand 사용하여 코드 리팩토링 수행 예정
    const [products, setProducts] = useState([]);
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [newProduct, setNewProduct] = useState({
        name: '',
        detail: '',
        installMethod: '',
        environment: '',
        asSupport: '',
        costPrice: '',
        price: '',
        saleQuantity: '',
        category: 'BEST',
        categoryName: '',
        itemStatus : 'SALE',
        tags: [],
        recommend : false,
        thumbFileName: null,
        detailImgFileName: null,
        videoUrl: null,
    });


    const fetchProducts = async () => {
        try {
            const res = await fetch('/api/admin/items');
            const data = await res.json();
            setProducts(data.items || []);
        } catch (err) {
            console.error("상품 불러오기 실패", err);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewProduct(prev => ({ ...prev, [name]: value }));
    };

    // const handleImageChange = (e) => {
    //     const { name, files } = e.target;
    //     setNewProduct(prev => ({ ...prev, [name]: files[0] }));
    // };

    // select 태그의 경우 value가 string
    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setNewProduct(prev => ({ ...prev, [name]: value }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            'itemName': newProduct.name,
            'itemDescription': newProduct.detail,
            'installMethod': newProduct.installMethod,
            'environment': newProduct.environment,
            'asSupport': newProduct.asSupport,
            'costPrice': Number(newProduct.costPrice),
            'salePrice': Number(newProduct.price),
            'saleQuantity': Number(newProduct.saleQuantity),
            'category': newProduct.category,
            'categoryName': newProduct.categoryName,
            'itemStatus': newProduct.itemStatus,
            'tags': newProduct.tags,
            'recommend': newProduct.recommend,
            'thumbFileName': newProduct.thumbFileName,
            'detailImgFileName': newProduct.detailImgFileName,
        };

        if (newProduct.videoUrl) data["videoUrl"] = newProduct.videoUrl;
        if (newProduct.thumbnail) data["thumbnail"] = newProduct.thumbnail;
        if (newProduct.detailImage) data["detailImage"] = newProduct.detailImage;

        const url = selectedProductId
            ? `/api/admin/item/update?itemId=${selectedProductId}`
            : '/api/admin/item/create';

        const method = selectedProductId ? 'PUT' : 'POST';

        const response = await fetch(url, {
            method,
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        if (response.ok) {
            alert(selectedProductId ? "상품 수정 완료!" : "상품 등록 성공!");
            fetchProducts();
            resetForm();
        } else {
            alert("상품 등록/수정 실패!");
        }
    };

    const resetForm = () => {
        setSelectedProductId(null);
        setNewProduct({
            name: '',
            detail: '',
            installMethod: '',
            environment: '',
            asSupport: '',
            costPrice: '',
            price: '',
            saleQuantity: '',
            category: '',
            categoryName: '',
            itemStatus : '',
            tags: [],
            recommend : false,
            thumbFileName: null,
            detailImgFileName: null,
            videoUrl: null,
        });
    };

    const handleProductClick = (product) => {
        setSelectedProductId(product.itemId);

        const fetchProduct = async () => {
            try {
                const res = await fetch(`/api/items/detail?itemId=${product.itemId}`);
                const data = await res.json();
                setNewProduct({
                    name: data.item.itemName,
                    detail: data.item.itemDescription,
                    installMethod: data.item.installMethod,
                    environment: data.item.environment,
                    asSupport: data.item.asSupport,
                    costPrice: data.item.costPrice,
                    price: data.item.salePrice,
                    saleQuantity: data.item.saleQuantity,
                    category: data.item.category,
                    categoryName: data.item.categoryName,
                    itemStatus: data.item.itemStatus,
                    thumbFileName: data.item.thumbFileName || "",
                    detailImgFileName: data.item.detailImgFileName || "",
                    tags: data.item.tags || [],
                    recommend: data.item.recommend || false,
                    videoUrl: data.item.videoUrl || "",
                });
            } catch (err) {
                console.error("상품 불러오기 실패", err);
            }
        }

        fetchProduct();
    };

    const handleImageChange = async (e) => {
        const { name, files } = e.target;

        // 파일이 선택되지 않은 경우
        if (!files || files.length === 0) {
            return;
        };

        const file = files[0];
        const formData = new FormData();
        formData.append("file", file);

        try {

            // 파일 타입 설정
            if (name === "thumbFileName") {
                formData.append("fileType", "thumbnail");
            } else if (name === "detailImgFileName") {
                formData.append("fileType", "detail");
            }

            // itemId 제공 (파일 업로드 시)
            // formData.append("itemId", selectedProductId);

            const response = await fetch("/api/upload-thumbnail-or-detail-file", {
                method: "POST",
                body: formData,
            });

            const result = await response.json();

            if (result.result === "success") {
                const fileName = result.d;

                // 썸네일 또는 상세이미지 경로 설정
                if (name === "thumbFileName") {
                    setNewProduct((prev) => ({
                        ...prev,
                        thumbFileName: fileName,
                    }));
                } else if (name === "detailImgFileName") {
                    setNewProduct((prev) => ({
                        ...prev,
                        detailImgFileName: fileName,
                    }));
                }

                alert("✅ 파일 업로드 성공!");
            } else {
                alert("❌ 파일 업로드 실패");
            }
        } catch (error) {
            console.error("파일 업로드 오류:", error);
            alert("서버 오류가 발생했습니다.");
        }
    };

    return (
        <div className="product-manager">
            <AdminSidebar />
            <h2>상품 관리</h2>

            <form className="product-form" onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="name"
                    placeholder="상품명"
                    value={newProduct.name}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="detail"
                    placeholder="상품 설명"
                    value={newProduct.detail}
                    onChange={handleChange}
                    required
                />

                <input type="text"
                    name="installMethod"
                    placeholder="설치 방법"
                    value={newProduct.installMethod}
                    onChange={handleChange}
                />

                <input type="text"
                    name="environment"
                    placeholder="환경"
                    value={newProduct.environment}
                    onChange={handleChange}
                />

                <input type="text"
                    name="asSupport"
                    placeholder="AS 지원"
                    value={newProduct.asSupport}
                    onChange={handleChange}
                />

                <input type="number"
                    name="costPrice"
                    placeholder="원가"
                    value={newProduct.costPrice}
                    onChange={handleChange}
                />

                <input
                    type="number"
                    name="price"
                    placeholder="판매가"
                    value={newProduct.price}
                    onChange={handleChange}
                    required
                />

                <input type="number"
                    name="saleQuantity"
                    placeholder="판매 수량"
                    value={newProduct.saleQuantity}
                    onChange={handleChange}
                />

                <select name="category" value={newProduct.category} onChange={handleSelectChange}>
                    <option value="BEST">BEST</option>
                    <option value="NEW">NEW</option>
                    <option value="DISCOUNTED">DISCOUNTED</option>
                    <option value="KCOMPANY">KCOMPANY</option>
                    <option value="NCOMPANY">NCOMPANY</option>
                    <option value="MARKETING">MARKETING</option>
                    <option value="ETC">ETC</option>
                </select>

                <input type="text"
                    name="categoryName"
                    placeholder="카테고리 이름"
                    value={newProduct.categoryName}
                    onChange={handleChange}
                />

                <select name="itemStatus" value={newProduct.itemStatus} onChange={handleSelectChange}>
                    <option value="SALE">SALE</option>
                    <option value="PENDING">PENDING</option>
                    <option value="STOP">STOP</option>
                </select>

                <input type="text"
                       name="tags"
                       placeholder="태그 (쉼표로 구분)"
                    value={newProduct.tags.join(', ')}
                    onChange={(e) => setNewProduct({ ...newProduct, tags: e.target.value.split(', ') })}
                />

                <input type="text"
                    name="videoUrl"
                    placeholder="유튜브 영상 URL"
                    value={newProduct.videoUrl}
                    onChange={handleChange}
                />

                <div className="recommend-checkbox">
                    <label>추천 상품 여부:</label>

                    <input type="checkbox"
                        name="recommend"
                           id="recommend"
                           placeholder="추천 상품 여부"
                        checked={newProduct.recommend}
                        onChange={(e) => setNewProduct({ ...newProduct, recommend: e.target.checked })}
                    />
                </div>

                <label>썸네일 이미지:
                    <input type="text" value={newProduct.thumbFileName} readOnly={true} onChange={handleChange} />
                    <input type="file" name="thumbFileName" accept="image/*" onChange={handleImageChange} />
                </label>
                <label>상세 이미지:
                    <input type="text" value={newProduct.detailImgFileName} readOnly={true} onChange={handleChange} />
                    <input type="file" name="detailImgFileName" accept="image/*" onChange={handleImageChange} />
                </label>
                <button type="submit">
                    {selectedProductId ? '상품 수정' : '상품 등록'}
                </button>
                {selectedProductId && (
                    <button type="button" onClick={resetForm} style={{ marginTop: '10px' }}>
                        수정 취소
                    </button>
                )}
            </form>

            <h3>등록된 상품</h3>
            <ul className="product-list">
                {products.map(p => (
                    <li key={p.itemId} onClick={() => handleProductClick(p)}>
                        <img src={p.thumbPath} alt="thumb" />
                        <div>{p.itemName}</div>
                        <div>{p.salePrice?.toLocaleString()}원</div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AdminProductManager;
